import PropTypes from 'prop-types';
import { Box, Card, CardContent, Typography } from '@mui/material';

const OverviewCard = ({
    title,
    icon,
    badge,
    action,
    height = '100%',
    minHeight = 180,
    contentInset = 0,
    children
}) => (
    <Card
        variant="outlined"
        sx={{
            height,
            minHeight,
            borderColor: '#E0E5E9',
            borderRadius: 2,
            boxShadow: '0 1px 3px rgba(38, 50, 56, 0.08)'
        }}
    >
        <CardContent
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                p: 2.25,
                '&:last-child': { pb: 2.25 }
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    minHeight: 32,
                    mb: 1.5
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        flexWrap: 'wrap',
                        minWidth: 0
                    }}
                >
                    <Box sx={{ display: 'flex', color: '#0A579B' }}>{icon}</Box>
                    <Typography
                        component="h2"
                        sx={{ color: '#263238', fontSize: '0.875rem', fontWeight: 700 }}
                    >
                        {title}
                    </Typography>
                    {badge}
                </Box>
                {action}
            </Box>

            <Box
                sx={{
                    display: 'flex',
                    flex: 1,
                    minHeight: 0,
                    flexDirection: 'column',
                    px: contentInset
                }}
            >
                {children}
            </Box>
        </CardContent>
    </Card>
);

OverviewCard.propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.node.isRequired,
    action: PropTypes.node,
    badge: PropTypes.node,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    minHeight: PropTypes.number,
    contentInset: PropTypes.number,
    children: PropTypes.node.isRequired
};

export default OverviewCard;
